<template>
  <div :class="[showStatus1?'task_pop_bg':'task_pop_bg2']">
    <!-- 标题 -->
    <div class="topSpot"></div>
    <div class="bottomSpot"></div>
    <div class="topBorder"></div>
    <div class="closeBtn" @click="close"></div>
    
    <div class="middleOutLine flexFather" style="width:100%;overflow:hidden;padding:0 10px;" v-show="showStatus1">
        <div style="display:flex;align-items:center;">
          <div class="headPorait">
            <img class="imgBorder" src="../../../theme-default/src/img/sosHead.png" alt="">
            <img class="imgHead" src="../../../theme-default/src/img/car_red.png" alt="">
           </div>
            <span  class="sos_info">山顶sos</span>
        </div>
        <div class="accept_box" @click="changeStatus"><img class="accept" src="../../../theme-default/src/img/accept.png" alt=""></div>
    </div>
    <div class="middleOutLine flexFather shuFlex" v-show="!showStatus1">
        <div style="display:flex;align-items:center;" class="shuFlex">
          <div class="headPorait">
            <img class="imgBorder" src="../../../theme-default/src/img/sosHead.png" alt="">
            <img class="imgHead" src="../../../theme-default/src/img/car_red.png" alt="">
           </div>
            <span  class="sos_info" style="margin-top:15px;">{{connectionStatus}}</span>
        </div>
        <div class="accept_box" style="margin-top:120px;margin-bottom:46px;" @click="close">
            <img class="accept" src="../../../theme-default/src/img/refuse.png" alt="">
        </div>
    </div>
    <div class="bottomBorder"></div>
  </div>
</template>
<script>
import MyApis from "../../../apis";
import ZJApp from "../../../../../app";
import waitAll from "../../../../../../utils/src/waitAll";
import { mapActions } from "vuex";
export default {
  data() {
    return {
      showStatus1:true,
      connectionStatus:"正在连接..."
    };
  },
  created: function() {
    if (this.$route.query.InfoId) {
      this.search();
    }
    if (this.$route.query.type == "look") {
      this.IsEdit = false;
    } else {
      this.IsEdit = true;
    }
  },
  mounted: function() {},
  watch: {
    $route: function() {
      if (this.$route.query.InfoId) {
        this.search();
      }
    },
  },
  methods: {
    ...mapActions(["submitConnect"]),
    changeStatus(){
      let _this=this;
      this.showStatus1 = false;
      this.submitConnect(true);
      setTimeout(function(){
       _this.connectionStatus="通话中..."
      },3000)
    },
    close(){
       this.$emit("closeSOS",false)
    },
   
  },
};
</script>
<style scoped lang="scss">
  .task_pop_bg{
    width:36.5%;
    position: fixed;
    left:50%;
    top:180px;
    z-index: 10000;
    margin-left:-18.2%;
    box-sizing: border-box;
    border-bottom-left-radius: 22px;
   }
   .task_pop_bg2{
    // width:36.5%;
    width:24%;
    position: fixed;
    left:50%;
    top:180px;
    z-index: 10000;
    margin-left:-12%;
    box-sizing: border-box;
    border-bottom-left-radius: 22px;
   }
    .topBorder{
      width:100%;
      height:34px;
      background: url("../../../../../../assets/pops.png") no-repeat;
      background-size: 100% 34px;
      position:relative;
    }
    .bottomBorder{
      width:100%;
      height:25px;
      background: url("../../../../../../assets/popBottom.png") no-repeat;
      background-size: 100%;
      
    }
    .closeBtn{
        width:20px;
        height:20px;
        background: url("../../../theme-default/src/img/close.png") no-repeat;
        background-size:20px;
        position: absolute;
        right:25px;
        top:20px;
        z-index: 12003;

    }
    .middleOutLine{
      border-left:0.5px solid #2ac1ff;
      border-right:0.5px solid #2ac1ff;
       background:rgba(26,49,70,0.3);
    }
    .notisfy{
        display: flex;
        justify-content: flex-start;
        align-items: center;
        margin-left: 9%;
    }
    .topSpot{
      width:222px;
      height:125px;
      background:url("../../../../../../assets/spot.png") no-repeat;
      position:absolute;
      right:10px;
      top:-62px;
      z-index:12000;
    }
    .bottomSpot{
      width:222px;
      height:120px;
      background:url("../../../../../../assets/spot.png") no-repeat;
      position:absolute;
      left:-35px;
      bottom:-45px;
      z-index:12000;
    }
    .flexFather{
     display: flex;
     align-items: center;
     justify-content: space-between;
     padding:2rem 2.5rem !important;
     .headPorait{
        width:16.2rem;
        height:16.2rem;
        border-radius:50%;
        position: relative;
        padding:0.1rem;
        box-sizing: border-box;
        .imgBorder{
            width:100%;
            height:100%;
            position:absolute;
            left: 0px;
            top:0px;
            animation: play 5s linear infinite;
        }
        .imgHead{
           width:100%;
           height:100%;
           border-radius:50%;
        } 
      }
      .sos_info{
            font-size: 16px;
            color:#e1c64c;
            margin-left:20px;
        }
      .accept_box{
          width:8.8rem;
          height:3.6rem;
          img{
              width:100%;
              height:100%;
          }
      }
    }
    


.shuFlex{
   flex-direction: column;
}
</style>
